<template>
    <div class="tile is-parent">
        <article class="tile is-child has-text-centered">
            <div class="tile is-ancestor">
                <div class="tile is-parent">
                    <article class="tile is-child box narrow">
                        <p class="title">
                            {{ transChoice('app.project.active', 2).titleCase() }}
                        </p>

                        <p class="subtitle">
                            {{ activeProjects }} <a :href="route('projects.index',{account_id: account.id, completed: 0})" class="tag is-light">View</a>
                        </p>
                    </article>
                </div>

                <div class="tile is-parent">
                    <article class="tile is-child box narrow">
                        <p class="title">{{ transChoice('app.company', 1).titleCase() }}</p>

                        <div class="level is-mobile center user-profile-list">
                            <div
                                v-for="user in companyUsers"
                                :key="user.id"
                                class="level-item is-narrow has-text-centered"
                            >
                                <a
                                    :href="route('company.user', {id: user.id})"
                                    class="user-profile has-text-centered"
                                >
                                    <img :src="user.extra_small_avatar ">
                                    <span class="hidden" v-text="user.name"></span>
                                </a>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </article>


    </div>
</template>

<script>
export default {
    props: {
        account: {
            type: Object,
            required: true,
        },
        companyUsers: {
            type: Object,
            required: true,
        },
        activeProjects: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {};
    },


};
</script>
